var map, infowindow, supermarkets, q, i;
var markers = [];
var kmzUrl;

function initMap(mapType) {
    var defaultLocation = new google.maps.LatLng(52.221537, 6.893662);
    var zoom = 14;

    if (mapType == 'contact') {
        // defaultlocation Grolsch HQ
        defaultLocation = new google.maps.LatLng(52.207028, 6.817124);
    }
    if (mapType == 'tastings' || mapType == 'campaignTastings') {
        defaultLocation = new google.maps.LatLng(52.2401870486056, 5.52045879829099);
        zoom = 8;
    }

    map = new google.maps.Map(document.getElementsByClassName('map')[0], {
        center: defaultLocation,
        zoom: zoom,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
            {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                stylers: [{ color: '#FFFFFF' }],
            },
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [{ color: '#023e84' }],
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#023e84' }],
            },
            {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [{ color: '#FFFFFF' }],
            },
            {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#E6EAF2' }, { weight: 1 }],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [{ color: '#FFFFFF' }],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#D6DDEA' }, { weight: 1.2 }],
            },
            {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#023e84' }],
            },
            {
                featureType: 'road',
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#FFFFFF' }, { weight: 3 }],
            },
            {
                featureType: 'administrative',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#c8073c' }],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#DDE3EE' }],
            },
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        ],
    });

    if (mapType == 'tastings' || mapType == 'campaignTastings') {
        infowindow = new google.maps.InfoWindow();

        var geocoder = new google.maps.Geocoder();
        document.getElementById('store-locator').addEventListener('submit', function() {
            geocodeAddress(geocoder, map);
        });
    }
    var icon = {
        path:
            'M66.9,41.8c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4c0,11.3,20.4,32.4,20.4,32.4S66.9,53.1,66.9,41.8z M37,41.4c0-5.2,4.3-9.5,9.5-9.5c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5C41.3,50.9,37,46.6,37,41.4z',
        fillColor: '#2da343',
        fillOpacity: 1,
        anchor: new google.maps.Point(42, 67),
        strokeWeight: 0,
        scale: 0.5,
    };

    if (mapType == 'tastings' || mapType == 'campaignTastings') {
        try {
            /* [MH] Het spijt me voor onderstaande.
            De KmlLayer service van google heeft een openbare URL nodig waar de .kmz uit gelezen kan worden.
            Het werkt dus ook niet door onderstaande URL aan te passen naar een lokale asset URL
            de url MOET ook eindigen op .kmz */
            var src;

            if (mapType == 'tastings') {
                src = 'https://www.grolsch.nl/dam/proeverijen.kmz?time=' + Date.now();
            } else if (mapType == 'campaignTastings') {
                src = kmzUrl + Date.now();
            }
            var kmlLayer = new google.maps.KmlLayer(src, {
                map: map,
            });
        } catch (error) {
            console.error(error);
        }
    }

    if (mapType == 'contact') {
        var marker = new google.maps.Marker({
            position: defaultLocation,
            map: map,
            icon: icon,
        });
    }
}

$('.geo').on('click', function() {
    var getSupermarkets = true;

    if ($(this).hasClass('tasting')) {
        getSupermarkets = false;
    }
    html5Geocode(getSupermarkets);
});

function html5Geocode(supermarkets) {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function(position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                map.setCenter(pos);
                map.setZoom(14);

                if (supermarkets) {
                    getSupermarkets(pos);
                }
            },
            function() {
                handleLocationError(true, infowindow, map.getCenter());
            }
        );
    } else {
        // Browser doesn't support Geolocation
        handleLocationError(false, infowindow, map.getCenter());
    }
}

function setMapOnAll(map) {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
    }
}

function getSupermarkets(location) {
    setMapOnAll(null);

    var service = new google.maps.places.PlacesService(map);
    service.nearbySearch(
        {
            location: location,
            radius: 1000,
            type: ['supermarket'],
        },
        callback
    );
}

function callback(results, status) {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
        for (var i = 0; i < results.length; i++) {
            createMarker(results[i]);
        }
    }
}

function createMarker(place) {
    var icon = {
        path:
            'M66.9,41.8c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4c0,11.3,20.4,32.4,20.4,32.4S66.9,53.1,66.9,41.8z M37,41.4c0-5.2,4.3-9.5,9.5-9.5c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5C41.3,50.9,37,46.6,37,41.4z',
        fillColor: '#2da343',
        fillOpacity: 1,
        anchor: new google.maps.Point(42, 67),
        strokeWeight: 0,
        scale: 0.5,
    };

    var marker = new google.maps.Marker({
        map: map,
        position: place.geometry.location,
        icon: icon,
    });

    markers.push(marker);

    google.maps.event.addListener(marker, 'click', function() {
        var content = '<strong>' + place.name + '</strong><br />' + place.vicinity;
        infowindow.setContent(content);
        infowindow.open(map, this);
    });
}

function geocodeAddress(geocoder, resultsMap) {
    var address = document.getElementById('address').value;
    if (address !== '') {
        geocoder.geocode({ address: address }, function(results, status) {
            if (status === 'OK') {
                resultsMap.setCenter(results[0].geometry.location);
                resultsMap.setZoom(14);
            } else {
                alert('De ingevoerde plaats kon niet worden opgehaald.');
            }
        });
    }
}

function handleLocationError(browserHasGeolocation, infowindow, pos) {
    // infowindow.setPosition(pos);
    // infowindow
    //     .setContent
    //     // browserHasGeolocation
    //     //     ? "Error: The Geolocation service failed."
    //     //     : "Error: Your browser doesn't support geolocation."
    //     ();
    // infowindow.open(map);

    console.log('The Geolocation service failed');
}

//
//
// START ONLOAD
//
//
function startMaps(mapType) {
    var googleMapsKey = _mgnl.googleMapsKey;

    $.getScript('https://maps.google.com/maps/api/js?key=' + googleMapsKey + '&libraries=places')
        .done(function(script, textStatus) {
            // Google map script loaded successfully
            initMap(mapType);
        })
        .fail(function(jqxhr, settings, ex) {
            // Could not load Google Map script
        });
}

$(function() {
    var $map = $('.map');
    if ($map.length > 0) {
        if ($('body').hasClass('contact')) {
            startMaps('contact');
        }
        if ($('body').hasClass('tasting-detail')) {
            startMaps('tastings');
        }
        if ($('section').hasClass('campaign-tasting')) {
            startMaps('campaignTastings');
        }
    }
});
